<template>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5 5L6 3L7 5L9 6L7 7L6 9L5 7L3 6L5 5Z" stroke="currentColor" stroke-linecap="round"/>
        <path d="M18 16L19 14L20 16L22 17L20 18L19 20L18 18L16 17L18 16Z" stroke="currentColor" stroke-linecap="round"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M19.6776 5.82843L18.2634 4.41421L14.3743 8.3033L15.7886 9.71751L19.6776 5.82843ZM18.9705 3.70711C18.58 3.31658 17.9468 3.31658 17.5563 3.70711L2.70708 18.5563C2.31655 18.9469 2.31655 19.58 2.70708 19.9706L4.12129 21.3848C4.51182 21.7753 5.14498 21.7753 5.5355 21.3848L20.3847 6.53553C20.7753 6.14501 20.7753 5.51184 20.3847 5.12132L18.9705 3.70711Z" fill="currentColor"/>
    </svg>
</template>

<script>
export default {
    name: 'SVGMagicApply',
};
</script>

<style scoped lang="scss">

</style>
